<template>
  <div class="container">
    <van-field
      v-model="phone"
      label="手机号"
      placeholder="请输入手机号"
      maxlength="11"
    />
    <van-button @click="getCode" type="primary" class="btn">获取</van-button>
    <div style="margin-top:10px;">验证码:{{ code }}</div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      code: '',
      phone: ''
    }
  },
  created() {},
  methods: {
    getCode() {
      const params = {
        phone: this.phone
      }
      let data = this.$Base64.encode(JSON.stringify(params))
      this.$api.getSmsCode(data).then(res => {
        let code = JSON.parse(this.$Base64.decode(res))
        this.code = code.data
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.container {
  display: flex;
  flex-direction: column;
  .btn {
    margin-top: 10px;
  }
}
</style>
